import { createSelector } from "reselect";
import { RootState } from "../../../redux/store";
import { IFlyerFilterOptions, IFlyerState } from "../types/flyer-state/flyer-state.interface";
import Store from "../../../redux/store";
import * as actions from "./flyer.actions";
import { IFlyerFilters } from "../types/flyer-filter.interface";
import { FlyerCreateForm } from "../types/flyer-create-form/flyer-create-form.interface";
import { LOADING_STATES } from "../../../features/loading";
import { IFlyerDetailState } from "../pages/flyer-detail/types/flyer-detail-state/flyer-detail-state.interface";
import { IUser } from "../../../types/user/iuser.interface";

export const getFlyerState = (state: RootState): any => state.flyerState;

export const getErrors = createSelector(getFlyerState, (state: IFlyerDetailState) => state.errors);

export const getFlyers = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.searchResults
);

export const isCreateModalOpen = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.isCreateModalOpen
);

export const isGridView = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.isGridView
);

export const isLoading = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.loading.status === LOADING_STATES.loading.status
);

export const getFilters = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.filters
);

export const getPermissions = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.permissions
);

export const getFlyerOwners = createSelector(
  getFlyerState,
  (flyerState: IFlyerState) => flyerState.filterOptions.owners
);

export function create(form: FlyerCreateForm) {
  Store.dispatch(actions.create(form));
}

export function fetchFlyers(filters: IFlyerFilters) {
  Store.dispatch(actions.fetch(filters));
}

export function deleteFlyer(id: number) {
  Store.dispatch(actions.deleteFlyer(id));
}

export function toggleModal(currentValue: boolean) {
  Store.dispatch(actions.setModalOpenState(!currentValue));
}

export function initPermissions(user: IUser) {
  Store.dispatch(actions.initPermissions(user));
}

export function setGridView(gridView: boolean) {
  Store.dispatch(actions.setGridView(gridView));
}

export function fetchFilterOptions() {
  Store.dispatch(actions.fetchFilterOptions());
}

export function setFilterOptions(filterOptions: IFlyerFilterOptions) {
  Store.dispatch(actions.setFilterOptions(filterOptions));
}
